export default function VirtualArchitecture() {
  return <div>Virtual Architecture Project Page</div>;
}

